<template>
  <div class="email-with-repeat">
  <b-form-group class="mb-0" label="email" label-class="visually-hidden">
    <Email
      ref="Email"
      :name="name"
      :email.sync="email_"
      :invalid.sync="invalid">
      <template v-for="slot in possibleChildSlotsFor('Email')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Email>
    <Email
      ref="Repeat"
      :name="`${name}-repeat`"
      :email.sync="repeat_"
      :invalid.sync="invalidRepeat"
      :validate-same-as="email_"
    >
      <template v-for="slot in possibleChildSlotsFor('Repeat')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Email>
  </b-form-group>
  </div>
</template>

<script>
import Email from './Email.vue'
import syncProperty from '../../../../mixins/syncProperty'
import slotProxy from '../../../../mixins/slotProxy'
export default {
  name: 'EmailWithRepeat',
  components: { Email },
  data () {
    return {
      invalid: false,
      invalidRepeat: false
    }
  },
  mixins: [
    syncProperty('email', 'email_'),
    syncProperty('repeat', 'repeat_'),
    slotProxy()
  ],
  watch: {
    anyInvalid: {
      immediate: true,
      handler: function (newValue) {
        this.$emit('update:invalid', newValue)
      }
    }
  },
  computed: {
    anyInvalid () {
      return this.invalid || this.invalidRepeat
    }
  },
  props: {
    name: {
      type: String,
      default: 'email'
    }
  }
}
</script>
